class DynamicYieldEvents {

	constructor() {
		this.userNavSaleClick();
		this.shopthelookTriggerClick();
		this.alternativeProductPerSizeClick();
	}

	/**
	 * Event if alternative product per size trigger gets clicked on pdp.
	 */
	alternativeProductPerSizeClick() {
		document.addEventListener( 'click', ( ev ) => {
			const targetEl = ev.target.closest( '.en_button--soldout' ) && ev.target.closest( '.en_mdl_article_detail__size-choice' );
			if ( targetEl ) {
				if ( 'undefined' !== typeof DY ) {
					window.DY.API( 'event',
						{
							name: 'ALTERNATIVEPRODUCTPERSIZE_TRIGGER_CLICKED',
						},
					);
				}
			}
		} );
	}

	/**
	 * Event if shop the look trigger gets clicked.
	 */
	shopthelookTriggerClick() {
		document.addEventListener( 'click', ( ev ) => {
			const targetEl = ev.target.closest( '.shopthelook_button' );
			if ( targetEl ) {
				if ( 'undefined' !== typeof DY ) {
					window.DY.API( 'event',
						{
							name: 'SHOPTHELOOK_TRIGGER_CLICKED',
						},
					);
				}
			}
		} );
	}

	/**
	 * Event if sale user nav item gets clicked.
	 */
	userNavSaleClick() {
		document.addEventListener( 'click', ( ev ) => {
			const targetEl = ev.target.closest( '.mdl_header__user-nav-item--sale .mdl_header__user-nav-item-link' );
			if ( targetEl ) {
				if ( 'undefined' !== typeof DY ) {
					window.DY.API( 'event',
						{
							name: 'SALE_USER_NAV_CLICKED',
						},
					);
				}
			}
		} );
	}
}

const initDynamicYieldEvents = () => {
	window.SL_DY_EVENTS ??= new DynamicYieldEvents();
	return window.SL_DY_EVENTS;
}

export {
	DynamicYieldEvents as default,
	initDynamicYieldEvents
}
